<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  ></div>
</template>

<script>
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { initializeMoEngageTime } from "../helpers/moengageEvents";
import { initializeMetaTime } from "../helpers/metaEvents";
import {
  loadAmplitudeUnsentEvents,
  EVENT_PAGEVIEW_LOCATIONPAGE,
} from "../helpers/analyticsEvents";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
// import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import Utility from "../helpers/utility";

export default {
  name: "InitializeLocation",
  components: {},
  data() {
    return {
      sessionDependedMethodsProcessed: false,
    };
  },
  async mounted() {
    this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false);

    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    loadAmplitudeUnsentEvents();

    if (!LocalStorageFunc.accessToken()) {
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {});
    }
    setTimeout(() => {
      initializeMoEngageTime();
      initializeMetaTime();
    }, 5000);

    Utility.osBackButtonFunc();
    EVENT_PAGEVIEW_LOCATIONPAGE();
  },
  methods: {},
  computed: {
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.$store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE);
        this.$store.dispatch(keyMapsAction.LOAD_LOGIN_STATUS, {});
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>
